import React, { useEffect, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Menu, X, Globe } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const {
    language,
    setLanguage,
    t
  } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: t.nav.home,
    href: '#home'
  }, {
    name: t.nav.rainforest,
    href: '#rainforest'
  }, {
    name: t.nav.boat,
    href: '#boat'
  }, {
    name: t.nav.gallery,
    href: '#gallery'
  }, {
    name: t.nav.reviews,
    href: '#reviews'
  }, {
    name: t.nav.faq,
    href: '#faq'
  }];
  const toggleLanguage = () => {
    setLanguage(language === 'es' ? 'en' : 'es');
  };
  return <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-169">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-170">
        <div className="flex justify-between items-center" data-id="element-171">
          {/* Logo Area (intentionally empty) */}
          <div className="flex-shrink-0" data-id="element-172" />

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-173">
            {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm font-medium transition-colors hover:text-turquoise ${isScrolled ? 'text-gray-700' : 'text-white drop-shadow-md'}`} data-id="element-174">
                {link.name}
              </a>)}

            {/* Language Toggle */}
            <button onClick={toggleLanguage} className={`flex items-center gap-1 text-sm font-bold px-3 py-1 rounded-full border transition-colors ${isScrolled ? 'border-gray-300 text-gray-700 hover:bg-gray-100' : 'border-white/50 text-white hover:bg-white/20'}`} data-id="element-175">
              <Globe size={16} data-id="element-176" />
              {language.toUpperCase()}
            </button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center gap-4" data-id="element-177">
            <button onClick={toggleLanguage} className={`flex items-center gap-1 text-sm font-bold ${isScrolled ? 'text-gray-700' : 'text-white'}`} data-id="element-178">
              <Globe size={18} data-id="element-179" />
              {language.toUpperCase()}
            </button>
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className={`${isScrolled ? 'text-gray-900' : 'text-white'}`} data-id="element-180">
              {mobileMenuOpen ? <X size={24} data-id="element-181" /> : <Menu size={24} data-id="element-182" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-183">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-gray-100 shadow-xl overflow-hidden" data-id="element-184">
            <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-185">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="block px-3 py-3 text-base font-medium text-gray-800 hover:bg-gray-50 hover:text-turquoise rounded-md" data-id="element-186">
                  {link.name}
                </a>)}
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}